import { render, staticRenderFns } from "./GetInTouchBlock.vue?vue&type=template&id=cff68558"
import script from "./GetInTouchBlock.vue?vue&type=script&lang=js"
export * from "./GetInTouchBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports